import {
    CollectionResponseType,
    GridResourceCollectionInterface
} from "../../../store/interfaces/GridResourceCollectionInterface";
import {apiTeamsMyTeamWithDaysOffGet, TeamMemberWithDayOffCountOutput} from "../../../generated";
import UiBus from "../../../store/service/UiBus";
import {action, observable} from "mobx";

export class DaysOffManageListStore implements GridResourceCollectionInterface<TeamMemberWithDayOffCountOutput> {
    @observable collectionResponse: CollectionResponseType<TeamMemberWithDayOffCountOutput> | null = null;
    @observable isLoading = false;

    constructor(private uiBus: UiBus) {
    }

    @action fetchCollection(query): void {
        this.isLoading = true;
        apiTeamsMyTeamWithDaysOffGet()
            .then(action(response => {
                this.collectionResponse = {
                    "hydra:member": response,
                    "hydra:search": null,
                    "hydra:totalItems": response.length,
                    "hydra:view": null,
                }
            }))
            .finally(action(() => {
                this.isLoading = false;
            }))
            .catch((error) => {
                this.uiBus.notify("Something went wrong", "warning");
            })
    }

    @action toggleLoading(): void {
        this.isLoading = !this.isLoading;
    }

}